import Currency from 'react-currency-formatter';
import { useCurrency } from 'shared/hooks/api/billing';

const QBenchCurrency = ({ quantity }) => {
    const { data: { code: currencyCode } } = useCurrency()

    return <Currency currency={currencyCode} quantity={quantity ?? 0} />
}

export default QBenchCurrency;